/* import __COLOCATED_TEMPLATE__ from './subaccount-name-input.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import { focusOnTemporaryInput } from '@banking/ui/utils/dom';
import environment from '@square/environment-utils/environment';
let SubaccountNameInput = (_class = class SubaccountNameInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "showEditIcon", _descriptor2, this);
    _defineProperty(this, "inputElement", null);
  }
  focus(el) {
    let tempInput = null;
    this.inputElement = el;
    const {
      isIOS
    } = environment();
    /**
     * https://stackoverflow.com/a/55652503
     * On IOS, if there is a delay before setting focus(e.g. waiting for marketDialoagLoaded event)
     * autofocus attribute doesn't work, unless another input already has focus
     */
    if (isIOS && document.activeElement !== this.inputElement) {
      tempInput = focusOnTemporaryInput();
    }

    // The market modal takes a second to appear and so the ember ways of
    // autofocusing don't work because they fire too fast.
    // The normal HTML attribute works the first time but not on subsequent
    // renders for some reason.
    const modal = el.closest('market-modal-partial');
    modal?.addEventListener('marketDialogLoaded', () => {
      this.resizeInput(el);
      later(() => {
        el.focus();
        tempInput?.remove();
      }, 1);
    }, {
      // For some reason this event seems to fire twice
      // https://github.com/squareup/market/issues/3822
      once: true
    });
    // Market dialog may already be loaded, so ensure we are always calling this.resizeInput
    // UI needs extra time to render the input content and set the input width
    later(() => {
      this.resizeInput(el);
    }, 1);
  }
  onInput(event) {
    if (event.target) {
      this.resizeInput(event.target);
    }
  }
  focusInput() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  }
  resizeInput(el) {
    el.style.width = 'auto';
    // Ensure input width is not too small so that user can always click on it
    if (el.scrollWidth > 32) {
      // By default the input width is large which is causing the edit icon to be rendered far from the input text
      // when text is short. "size" changes the minimum width of input
      // We are setting this in JS instead of HBS to prevent flickering effect happens occasionally
      el.size = 3;
      el.style.width = `${el.scrollWidth}px`;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showEditIcon", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype)), _class);
export { SubaccountNameInput as default };